export const getCustomTowToDestinationList = (state) =>
  state.generalInfo.towToCustomDestinationList;
export const getPpuFuelPrice = (state) => state.generalInfo.ppuFuelPrice;
export const getDuplicateRescue = (state) => state.generalInfo.duplicateRescue;
export const getPrimaryLookup = (state) => state.generalInfo.isPrimaryLookup;
